import Typography from '@alltrails/core/components/Typography';
import Button from '@alltrails/denali/components/Button';
import LoadingDots from '@alltrails/denali/components/LoadingDots';
import SectionMessage from '@alltrails/denali/components/SectionMessage';
import PageUISectionList from '@alltrails/layout/components/PageUI/PageUISectionList/PageUISectionList';
import type useAskResponse from '@/hooks/useAskResponse';
import type { AskAllTrailsRequest } from '@/utils/askAllTrailsApi';
import { useAppDispatch } from '@/utils/redux';
import { askQuestion } from '@/utils/slices/askSlice';
import styles from './AskSidebar.module.scss';

type Props = Omit<ReturnType<typeof useAskResponse>, 'request'> & {
  request: AskAllTrailsRequest;
};

/**
 * The submitted question, then the answer, or where the request is up to.
 */
const AskResponse = ({ error, isFetching, page, request }: Props) => {
  const dispatch = useAppDispatch();

  const loadingLabel = 'Searching trails and reviews…'; // hwandrew TODO: XPLR-204 translations
  const genericErrorMessage = 'Something went wrong. Please try again.'; // hwandrew TODO: XPLR-204 translations
  const retryLabel = 'Try again'; // hwandrew TODO: XPLR-204 translations

  return (
    <div className={styles.response}>
      <Typography className={styles.question} component="p" variant="text200">
        {request.query}
      </Typography>
      {isFetching && (
        <div className={styles.loading} role="status">
          <LoadingDots />
          <Typography component="span" variant="text200">
            {loadingLabel}
          </Typography>
        </div>
      )}
      {error && (
        <div className={styles.error}>
          <SectionMessage text={error.message ?? genericErrorMessage} variant="error" />
          {error.canRetry && (
            <Button onClick={() => dispatch(askQuestion({ location: request.location, question: request.query }))} size="md" text={retryLabel} />
          )}
        </div>
      )}
      {page && <PageUISectionList page={page} />}
    </div>
  );
};

export default AskResponse;
